export default "__VITE_ASSET__MsUcK0Jk__"